module.exports = __webpack_public_path__ + "media/beep-07a.d932c606.mp3";